import React from 'react'
import PropTypes from 'prop-types'

const personalDataSVG = ({ color, width, height }) => (
    <svg viewBox="0 0 24 24" idth={width} height={height}>
        <g>
            <path
                d=" M 12 2 C 7.03 2 3 6.03 3 11 C 3.156 16.656 8.023 19.578 10.031 20.031 C 12.039 20.484 12.891 20.273 14.031 20.031 C 15.172 19.789 21 16.922 21 11 C 21 6.03 16.97 2 12 2 Z  M 12 4 C 13.66 4 15 5.34 15 7 C 15 8.66 13.66 10 12 10 C 10.34 10 9 8.66 9 7 C 9 5.34 10.34 4 12 4 Z  M 12 18.3 C 9.5 18.3 7.29 17.02 6 15.08 C 6.03 13.09 10 12 12 12 C 13.99 12 17.97 13.09 18 15.08 C 16.71 17.02 14.5 18.3 12 18.3 Z "
                fill={color}/>
            <path d=" M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 Z " fill="none"/>
        </g>
    </svg>
)

personalDataSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

personalDataSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default (personalDataSVG)
